import { render, staticRenderFns } from "./ConfirmationLoader.vue?vue&type=template&id=0405b86a&"
import script from "./ConfirmationLoader.vue?vue&type=script&lang=js&"
export * from "./ConfirmationLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports